var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _path, _path2, _path3, _path4, _path5, _g, _path6, _path7;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPatientDecree(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 104,
    height: 94,
    viewBox: "0 0 104 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 82,
    height: 94,
    rx: 2,
    fill: "#FFEADB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 16,
    width: 38,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 42,
    width: 38,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 68,
    width: 38,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 23,
    width: 28,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 49,
    width: 28,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 75,
    width: 28,
    height: 3,
    rx: 1,
    fill: "#EF7C00"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 13,
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 39,
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 65,
    width: 16,
    height: 16,
    rx: 2,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14 21L17 24L23 18",
    stroke: "#A7163E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 48L17 51L23 45",
    stroke: "#A7163E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14 73L17 76L23 70",
    stroke: "#A7163E",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5512 33.1855L55.9687 74.768L62.8733 81.045L103.999 39.9194L101.77 37.5084L97.5512 33.1855Z",
    fill: "#E62645"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10675:21654",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 55,
    y: 33,
    width: 49,
    height: 49
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M97.5512 33.1855L55.9687 74.768L62.8733 81.045L103.999 39.9194L101.77 37.5084L97.5512 33.1855Z",
    fill: "#E62645"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10675:21654)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.204 38.7139L62.8733 81.044L59.1072 77.9056L101.168 35.8438L102.593 36.3029L105.204 38.7139Z",
    fill: "#A7163E"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.9695 74.7676L50.3203 87.3214L62.8742 81.0445L55.9695 74.7676Z",
    fill: "#D7AE88"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M50.3203 87.3203L55.7605 84.6005L52.8524 81.6924L50.3203 87.3203Z",
    fill: "#4B4A50"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPatientDecree);
export default __webpack_public_path__ + "static/media/patientDecree.8fdfac64cc4d41a5e14455ee5533bde3.svg";
export { ForwardRef as ReactComponent };